import { render, staticRenderFns } from "./ApartmentDetails.vue?vue&type=template&id=6ba6d96b&scoped=true&"
import script from "./ApartmentDetails.vue?vue&type=script&lang=js&"
export * from "./ApartmentDetails.vue?vue&type=script&lang=js&"
import style0 from "./ApartmentDetails.vue?vue&type=style&index=0&id=6ba6d96b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ba6d96b",
  null
  
)

export default component.exports